module.exports = __webpack_public_path__ + "img/canping-about.2df0cbf5.jpg";